import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LangContext = createContext({ lang: 'fr', setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('site_lang') || 'fr';
    } catch (_) {
      return 'fr';
    }
  });

  useEffect(() => {
    try { localStorage.setItem('site_lang', lang); } catch (_) {}
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang }), [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

